import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    copy: 'Copy',
    hideDetails: 'Hide details',
    revealDetails: 'Show details',
  },
  fr: {
    copy: 'Copier',
    hideDetails: 'Cacher les détails',
    revealDetails: 'Afficher les détails',
  },
});

export default locales;
